import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import { Twitter } from "./twitter"
import { Discord } from "./discord"

import "./header.css"

const Header = ({ siteTitle }) => (
  <header class="header-outer">
    <div class="header-inner">
      <Link
        to="/"
      >
        URBAN WILDLIFE NFT
      </Link>
      <div class="filler" />
      <div class="header-right">
        <div class="parent">
        </div>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
